import { storage } from '../utils';

// Placeholder for local storage
const namespace = 'ACCOUNT';

const User = {
  /**
   * It saves the given user information in the "Local Storage" section
   *
   * @param {Object} value Data to be updated
   * @return {void}
   */
  setUserInfo(value) {
    storage.set(namespace, value);
  },

  /**
   * The given user stores the Token in the "Local Storage" section
   *
   * @param {string} value Updated token
   * @return {void}
   */
  setToken(value) {
    const state = storage.get(namespace);
    state.Token = value;
    state.token = value;
    storage.set(namespace, state);
  },

  /**
   * The user returns the information.
   * It returns "null" if there is no user.
   *
   * @return {UserInfo}
   */
  getUserInfo() {
    return storage.get(namespace);
  },

  /**
   * The user rolls back the Token.
   * It returns "null" if there is no user.
   *
   * @return {string}
   */
  getToken() {
    const state = storage.get(namespace);
    return state && state.token;
  },

  /**
   * All user data will be deleted and the user will exit.
   *
   * @return {void}
   */
  clear() {
    storage.clear();
  },
};

/**
 * Checks if the user has a valid AI API key
 * @param {object} user
 * @returns {boolean}
 */
export function isValidAiApiKey(user) {
  return !!(
    user
    && typeof user.aiApiKey === 'string'
    && user.aiApiKey.trim()
    && !['0', 'false', 'null', 'undefined'].includes(user.aiApiKey.trim())
  );
}

export default User;
